import { Logger } from '@grandstand-web/utils/logger'
import { TDeviceInfo } from '../types'
import { getTizenVersion } from './getTizenVersion'

const logger = Logger.of('getTizenNativeInfo')

const getIsPermissionsError = (error: any) => {
  if (error && typeof error?.message === 'string') {
    return error.message.toLowerCase().indexOf('undefined') === -1
  }
  return false
}

export const getTizenNativeInfo = async (): Promise<TDeviceInfo> => {
  const deviceInfo: TDeviceInfo = {
    nativeVersion: 'unknown',
    apiVersion: getTizenVersion(),
  }

  // emulators often leave `window.webapis` and `window.tizen` undefined
  if (typeof window.webapis === 'undefined') {
    return deviceInfo
  }

  const { productinfo, adinfo: tizenAdInfo } = await import('tizen-tv-webapis')

  try {
    const info = window.tizen?.application?.getAppInfo()
    deviceInfo.nativeVersion = info?.version ?? 'unknown'
  } catch (error) {
    if (getIsPermissionsError(error)) {
      logger.warn('ERROR @ tizen.application.getAppInfo() for appVersion: ', error)
    }
  }

  try {
    deviceInfo.isLAT = tizenAdInfo.isLATEnabled()
  } catch (error: any) {
    // ignore 'undefined' errors (See https://developer.samsung.com/smarttv/develop/api-references/samsung-product-api-references/adinfo-api.html#Methods)
    if (getIsPermissionsError(error)) {
      logger.warn(`ERROR @ ti.adinfo.isLATEnabled() for is_lat: `, error)
      // Error, such as a missing privilege.
      // Client app likely needs force-updated
    }
  }

  try {
    deviceInfo.advertisingId = tizenAdInfo.getTIFA()
  } catch (error: any) {
    if (getIsPermissionsError(error)) {
      logger.warn(`ERROR @ ti.adinfo.getTIFA() for did: `, error)
    }
  }

  try {
    deviceInfo.deviceMake = (productinfo as any)?.getLicensedVendor()
  } catch (error: any) {
    if (getIsPermissionsError(error)) {
      logger.warn(`ERROR @ ti.productInfo.getLicensedVendor() for device_make: `, error)
    }
  }

  try {
    deviceInfo.deviceModel = productinfo?.getRealModel()
  } catch (error: any) {
    if (getIsPermissionsError(error)) {
      logger.warn(`ERROR @ ti.productinfo.getModel() for device_model: `, error)
    }
  }

  return deviceInfo
}
